// src/utils/cdnUtils.ts

/**
 * Presigned URL veya S3 URL bilgisinden CDN URL'si oluşturur
 */
export const convertS3ToCdnUrl = (
  s3Url: string | null | undefined
): string | null => {
  if (!s3Url) return null;

  try {
    const pathRegex = /amazonaws\.com\/([^?]+)/;
    const match = s3Url.match(pathRegex);

    if (match && match[1]) {
      const filePath = match[1];
      return `https://cdn.saloncepte.com/${filePath}`;
    }

    return null;
  } catch (error) {
    console.error("CDN URL dönüştürme hatası:", error);
    return null;
  }
};

/**
 * S3 kodundan veya tam dosya yolundan CDN URL'si oluşturmak için kullanılır
 */
export const getCdnUrlFromCode = (
  code: string | null | undefined,
  prefix?: string
): string | null => {
  if (!code) return null;

  // Eğer code içinde doğruca bir yol varsa
  if (code.includes("/")) {
    return `https://cdn.saloncepte.com/${code}`;
  }

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const pathPrefix = prefix ?? "8124/content";

  return `https://cdn.saloncepte.com/${pathPrefix}/${year}/${month}/${day}/${code}`;
};

/**
 * API'den dönen presignedResult objesinden CDN URL oluşturur
 */
export interface PresignedResult {
  url?: string;
  code?: string;
}

export const getCdnUrlFromPresignedResult = (
  presignedResult: PresignedResult | null | undefined
): string | null => {
  if (!presignedResult) return null;

  if (presignedResult.url) {
    return convertS3ToCdnUrl(presignedResult.url);
  }

  if (presignedResult.code) {
    return getCdnUrlFromCode(presignedResult.code);
  }

  return null;
};
